import toast from "react-hot-toast";

import { truckApi } from "../truck.api";
import { GetTruckModel, GetTruckModels, GetTruckModelsByBrand } from "./truckModels.types";

export const truckModelsApi = truckApi.injectEndpoints({
  endpoints: (build) => ({
    //! Truck Models
    getTruckModels: build.query<GetTruckModels["result"], GetTruckModels["args"]>({
      query: () => "/truck-model",
      onQueryStarted: async (args, { queryFulfilled }) => {
        toast.promise(queryFulfilled, {
          loading: "Carregando modelos de caminhão...",
          success: "Modelos de caminhão carregados com sucesso!",
          error: "Erro ao carregar modelos de caminhão."
        });
      }
    }),
    getTruckModel: build.query<GetTruckModel["result"], GetTruckModel["args"]>({
      query: ({ id }) => `/truck-model/${id}`,
      onQueryStarted: async (args, { queryFulfilled }) => {
        toast.promise(queryFulfilled, {
          loading: "Carregando modelo de caminhão...",
          success: "Modelo de caminhão carregado com sucesso!",
          error: "Erro ao carregar modelo de caminhão."
        });
      }
    }),
    getTruckModelsByBrand: build.query<GetTruckModelsByBrand["result"], GetTruckModelsByBrand["args"]>({
      query: ({ id }) => `/truck-model/brand/${id}`,
      onQueryStarted: async (args, { queryFulfilled }) => {
        toast.promise(queryFulfilled, {
          loading: "Carregando modelos de caminhão...",
          success: "Modelos de caminhão carregados com sucesso!",
          error: "Erro ao carregar modelos de caminhão."
        });
      }
    })
  })
});

truckModelsApi.enhanceEndpoints({
  addTagTypes: ["TruckModel"],
  endpoints: {
    getTruckModels: {
      providesTags: (result) =>
        result ? [...result.map(({ id }) => ({ type: "TruckModel" as const, id })), { type: "TruckModel", id: "LIST" }] : [{ type: "TruckModel", id: "LIST" }]
    },
    getTruckModel: {
      providesTags: (result, error, { id }) => [{ type: "TruckModel", id }]
    },
    getTruckModelsByBrand: {
      providesTags: (result, error, { id }) => [{ type: "TruckModel", id }]
    }
  }
});
